import LegalDocumentPage from "@/components/layout/LegalDocumentPage";
import { CONTACT_EMAIL } from "@/config/site";

const LAST_UPDATED = "February 22, 2026";

const sections = [
  {
    title: "1. Acceptance of Terms",
    paragraphs: [
      "By using this website, you agree to these Terms and Conditions. If you do not agree, please do not use the website.",
    ],
  },
  {
    title: "2. Website Information",
    paragraphs: [
      "Content on this website is provided for general information only and does not replace a face-to-face clinical assessment.",
    ],
  },
  {
    title: "3. Clinical and Emergency Disclaimer",
    paragraphs: [
      "Website content is not a diagnosis, treatment plan, or emergency advice. If you have urgent symptoms, contact an emergency dental provider or emergency services immediately.",
    ],
  },
  {
    title: "4. Appointments and Referrals",
    paragraphs: [
      "Submitting a website form, callback request, or referral does not create an immediate treatment agreement. Appointment availability and acceptance are subject to clinical review and practice capacity.",
    ],
  },
  {
    title: "5. Fees and Estimates",
    paragraphs: [
      "Any prices shown are guide prices unless clearly stated otherwise. Final fees are confirmed after examination and treatment planning.",
    ],
  },
  {
    title: "6. Communications",
    paragraphs: [
      "When you contact us using forms, email, phone, live chat, or WhatsApp, you agree that we may reply through the channel you provided for care coordination and appointment administration.",
    ],
  },
  {
    title: "7. Intellectual Property",
    paragraphs: [
      "All website text, branding, images, and design elements are owned by Specialist Dental London or used with permission. Reproduction without prior written consent is prohibited.",
    ],
  },
  {
    title: "8. Third-Party Links",
    paragraphs: [
      "This website may link to external websites or services. We are not responsible for the content, availability, or privacy practices of third-party services.",
    ],
  },
  {
    title: "9. Liability",
    paragraphs: [
      "To the fullest extent permitted by law, we exclude liability for loss arising from reliance on website-only information. Clinical decisions should be made after direct consultation with a qualified clinician.",
    ],
  },
  {
    title: "10. Changes and Contact",
    paragraphs: [
      "We may update these Terms and Conditions from time to time. Updated versions take effect when published on this page.",
      `For questions, contact ${CONTACT_EMAIL}.`,
    ],
  },
];

export default function Terms() {
  return (
    <LegalDocumentPage
      title="Terms & Conditions"
      lastUpdated={LAST_UPDATED}
      intro="These terms govern use of the Specialist Dental London website and online enquiry services."
      sections={sections}
      testIdPrefix="terms"
    />
  );
}
